import { toggleFullscreen } from '@/shared/utils';

export default {
  methods: {
    toggleFullscreen() {
      const video = document.querySelector('.js-player-video');
      const wrapper = document.querySelector('.js-player-wrapper');
      toggleFullscreen(video, wrapper);
    },
  },
};
